import { render, staticRenderFns } from "./ListTournamentsRating.vue?vue&type=template&id=5447d004&scoped=true"
import script from "./ListTournamentsRating.vue?vue&type=script&lang=js"
export * from "./ListTournamentsRating.vue?vue&type=script&lang=js"
import style0 from "./ListTournamentsRating.vue?vue&type=style&index=0&id=5447d004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447d004",
  null
  
)

export default component.exports